import Image from 'next/image'
import Section from 'components/common/Section'
import { SectionHeader } from 'components/marketing/SectionHeader'
import { Marketing, Label } from 'designsystem/Text'
import { Card } from 'designsystem/Card'
import { Button } from 'designsystem/Button'
import ExternalIcon from 'icons/ExternalIcon'
import { ComponentFeaturesCards } from 'types/generated/contentful'
import { useThemeColor } from './ThemeContext'

export const FeaturesCards = ({
  label,
  headline,
  subheadline,
  cardsTitle,
  ctaLabel,
  ctaUrl,
  featuresCollection,
}: ComponentFeaturesCards): JSX.Element => {
  const themeColor = useThemeColor()

  return (
    <Section bgColor='white'>
      <SectionHeader
        label={label!}
        title={headline!}
        subline={subheadline!}
        highlight={themeColor}
      />

      <div className='lg:-mt-10'>
        {cardsTitle && (
          <Label className='hidden md:block md:text-center md:text-neutral-60 md:mb-8'>
            {cardsTitle}
          </Label>
        )}

        <div className='neutralize-horizontal-padding lg:hidden'>
          <ul className='flex px-8 -mt-4 pt-4 pb-10 gap-5 overflow-x-auto'>
            {featuresCollection?.items.map((feature, i) => (
              <li key={i} className='w-[286px] flex-shrink-0'>
                <FeatureCard feature={feature} />
              </li>
            ))}
          </ul>
        </div>

        <div className='hidden lg:grid lg:grid-cols-3 lg:gap-5'>
          {featuresCollection?.items.map((feature, i) => (
            <FeatureCard key={i} feature={feature} />
          ))}
        </div>

        {ctaLabel && (
          <div className='mt-8 flex justify-center lg:mt-12'>
            <Button
              color='blue'
              pageType='marketing'
              hasArrow
              onClick={() => {
                window.open(ctaUrl!, '_blank')
              }}
            >
              {ctaLabel!}
            </Button>
          </div>
        )}
      </div>
    </Section>
  )
}

function FeatureCard({ feature }) {
  return (
    <Card noMaxWidth noPadding className='overflow-hidden h-full'>
      <Image
        width={feature!.image!.width!}
        height={feature!.image!.height!}
        src={feature!.image!.url!}
        alt={feature!.image!.title!}
      />
      <div className='p-6 border-t border-neutral-10'>
        <Marketing.H4>{feature?.title}</Marketing.H4>
        <p className='mt-6'>{feature?.text}</p>
        {feature!.linkLabel && (
          <div className='mt-6'>
            <a
              href={feature!.linkUrl!}
              target='_blank'
              rel='noopener noreferrer'
              className='inline-flex items-center gap-2 text-18 text-neutral-60 font-demibold'
            >
              {feature!.linkLabel}
              <ExternalIcon />
            </a>
          </div>
        )}
      </div>
    </Card>
  )
}
